var cloud = require('cloud/base/cloud');
var Header = require("./common/header");
var Nav = require("./common/nav");
var Footer = require("./common/footer");
var validator = require("cloud/components/validator");
require('./resources/css/common.css');
require('./resources/css/home.css');
require('./resources/css/verifyBrowser.css');
require('bootstrap/dist/css/bootstrap.css');
var emailAutoComplete = require("cloud/components/email-autocomplete");

var Content = require('./content.html');
var qrcode = require("qrcode-npm/qrcode");
/**
 * 判断是否为IE9以下浏览器
 * flag为false时，浏览器为为IE9或IE10
 */
var flag = function () {
  var bua = navigator.userAgent;
  var reg = new RegExp("MSIE ([5,6,7,8][/.0-9]{0,})");
  return !reg.exec(bua);
}();

$(function () {
  $('body').show();
  if (!flag) {//浏览器为为IE9以下时做如下操作
    $("<div id='tip_top' class='tip_top'></div>")
      .appendTo("body")
      .css({
        "height": (document.documentElement.clientHeight / 2),
        "width": document.documentElement.clientWidth,
        "top": -(document.documentElement.clientHeight / 2)
      }).animate({top: "0px"}, 300, function () {
        $("<div id='tip_content' class='tip_content'></div>").html("<div class='text_div_1'><image class='inhand_logo' src='./resources/images/Logo-InHand.png' />" +
          "<p class='text_title'>浏览器不受支持</p>" +
          "<p class='text_content'>使用当前浏览器，无法获得最佳体验，建议使用最新的" +
          "<a class='browser_link' href='http://www.firefox.com.cn'>Firefox</a>或" +
          "<a class='browser_link' href='http://www.google.cn/intl/zh-CN/chrome/browser/'>Chrome</a>浏览器</p></div>" +
          "<div class='text_div_2'>" +
          "<p class='text_title'>Browser Tip</p>" +
          "<p class='text_content'>Suggest to select the latest version of " +
          "<a class='browser_link' href='http://www.mozilla.org/en-US/firefox/new/'>Firefox</a> or " +
          "<a class='browser_link' href='https://www.google.com/intl/en/chrome/browser/'>Chrome</a> browser</p></div>"
        ).appendTo("body").css({
          "top": ((document.documentElement.clientHeight / 2) - 125) + "px",
          "left": ((document.documentElement.clientWidth / 2) - 225) + "px"
        });
        $("<div class='ignore_button'></div>").appendTo($("#tip_content")).text("Skip").mouseover(function () {
          $(this).css({
            "cursor": "pointer",
            "font-weight": "bold"
          })
            .mousedown(function () {
              $(this).css({
                "border-right": "2px solid #dddddd",
                "border-bottom": "2px solid #dddddd"
              })
            })
            .mouseout(function () {
              $(this).css({
                "border-right": "2px solid #7E807C",
                "border-bottom": "2px solid #7E807C",
                "font-weight": "normal"
              })
            })
        }).click(function () {
          $("#tip_bottom").animate({top: (document.documentElement.clientHeight) + "px"}, 300, function () {
            $(this).remove()
          });
          $("#tip_top").animate({top: -(document.documentElement.clientHeight / 2) + "px"}, 300, function () {
            $(this).remove()
          });
          $("#tip_content").fadeOut(300, function () {
            $(this).remove()
          });
        })
      });
    $("<div id='tip_bottom' class='tip_bottom'></div>").appendTo("body").css({
      "height": (document.documentElement.clientHeight / 2),
      "width": document.documentElement.clientWidth,
      "top": document.documentElement.clientHeight
    }).animate({top: (document.documentElement.clientHeight / 2) + "px"}, 300)
  }

  new Index();
});

var Index = Class.create(cloud.Component, {
  initialize: function ($super, options) {
//            $super(options);
    var self = this;
    this.header = null;
    this.navigate = null;
    this.footer = null;
    this._render();
    $("#home-input-user").focus();
  },

  _render: function () {
    var self = this;
    $('#content').html(Content);
    this._renderHeader();
    this._renderNav();
    this._renderFooter();
    this._effects();
    this._events();
    this._showAuthcode();
    this._validator();
    this._locale();
    this._setAboutUsLink();
    this._renderQRcode();
    this._emailAutoComplete();
    $("#home-input-pwd-password").focus(
      function () {
        if ($(this).attr("type") == "text") {
          $(this)[0].type = "password";
        }
      }
    );
    $("#download-dt-client").attr("href", require("file?name=resources/[name].[ext]!./../downloads/DeviceTouch.rar"));
  },
  /*邮箱自动补全功能*/
  _emailAutoComplete: function () {
    var data = [
      "inhand.com.cn",
      "qq.com",
      "126.com",
      "163.com",
      "sina.com",
      "sohu.com",
      "gmail.com",
      "icloud.com",
      "outlook.com",
      "googlemail.com",
      "yahoo.com",
      "hotmail.com",
      "live.com",
      "msn.com",
      "verizon.net",
      "facebook.com",
      "me.com",
      "mac.com",
      "139.com",
      "189.com",
      "wo.com.cn"];
    var autoComplete = new emailAutoComplete({
      elt: $("#home-input-user"),
      data: data
    });
  },
  _renderQRcode: function () { //使用插件生成二维码的方法
    var qr = qrcode.qrcode(6, 'M');

    var host = window.location.host;

    qr.addData("http://" + host + "/DeviceNetwork/downloads/Alarm.apk");
    qr.make();
    var imgTag = qr.createImgTag(6);
    $(".alarm-app-qrcode").append(imgTag);
  },
  _locale: function () {
    locale.render();
  },
  _setAboutUsLink: function () {
    //var lang = localStorage.getItem("language");
    var lang = "en";
    if (lang == 'en') {
      $("#home-nav-aboutus").children("a").attr("href", "http://www.inhandnetworks.com/");
    }
    else if (lang == 'zh_CN') {
      $("#home-nav-aboutus").children("a").attr("href", "http://www.inhand.com.cn/");
    }
    else {
      $("#home-nav-aboutus").children("a").attr("href", "http://www.inhandnetworks.com/");
    }
  },
  _renderHeader: function () {
    this.header = new Header({
      selector: "#common-header"
    });
  },

  _renderNav: function () {
    this.nav = new Nav({
      selector: "#common-nav",
      windowElement: "#home-content",
      current: 0
    });
  },

  _renderFooter: function () {
    this.footer = new Footer({
      selector: "#common-footer",
      contentElement: "#home-content"
    });

  },

  _validator: function () {
    validator.render("#formID", {
      promptPosition: "topRight",
      scroll: false,
    });
  },

  _showPasswordInput: function (focus) {
    $("#home-input-pwd-text").hide();
    $("#home-input-pwd-password").show();
    if (focus) {
      $("#home-input-pwd-password").focus();
    }
  },

  _showVercodeInput: function (focus) {
    $("#home-input-ver-default").hide();
    $("#home-input-ver-custom").show();
    if (focus) {
      $("#home-input-ver-custom").focus();
    }
  },

  _events: function () {
    var self = this;
    $("#home-verimg").children("img").click(function () {
      self._showAuthcode();
    });
    // 在输入框中给出提示
    $("#home-input-pwd-text").focus(function () {
      self._showPasswordInput(true);
    });

    $("#home-input-ver-default").focus(function () {
      self._showVercodeInput(true);
    });

    $("#home-content-bottom-div-center-text-button-DT").click(function () {
      if (locale.current() === 1) {
        window.open('http://www.inhandnetworks.com/devicenetworkscloud/device-touch.html', '_blank');
        return;
      }
      window.open('http://www.inhand.com.cn/product/m2m-cloud/equipment/device-touch.html', '_blank');
    }).mouseover(function () {
      $(this).css("background", "#5ed45a");
    }).mouseout(function () {
      $(this).css("background", "#70cb57");
    });

    $("#home-content-bottom-div-center-text-button-DS").click(function () {
      if (locale.current() === 1) {
        window.open('http://www.inhandnetworks.com/devicenetworkscloud/device-sense.html', '_blank');
        return;
      }
      window.open('http://www.inhand.com.cn/product/m2m-cloud/equipment/device-sense.html', '_blank');
    }).mouseover(function () {
      $(this).css("background", "#5ed45a");
    }).mouseout(function () {
      $(this).css("background", "#70cb57");
    });

    $("#home-content-bottom-div-center-text-button-DM").click(function () {
      if (locale.current() === 1) {
        window.open('http://www.inhandnetworks.com/devicenetworkscloud/device-manager.html', '_blank');
        return;
      }
      window.open('http://www.inhand.com.cn/product/m2m-cloud/equipment/device-manager.html', '_blank');
    }).mouseover(function () {
      $(this).css("background", "#5ed45a");
    }).mouseout(function () {
      $(this).css("background", "#70cb57");
    });
  },

  _effects: function () {
    var self = this;
    $("#home-login-forget").bind("click", function () {
      require(["./forget_pass"], function (Forgetpass) {
        var forgetpass = new Forgetpass({
          windowElement: "#home-content"
        });
      });
    });
    /* 登录按钮点击事件 */
    $("#home-input-submit").bind("click", function () {
      self._showPasswordInput();
      self._showVercodeInput();
      if (validator.result("#formID") && $("body").find(".inhand-dialog").length == 0 && $("body").find(".ui-window-content").length == 0) {
        self._login();
      }
    });
    $("body").keydown(function (event) {
      if ($("body").find(".inhand-dialog").length == 0 && $("body").find(".ui-window-content").length == 0) {
        if (event.keyCode == 13) {
          self._showPasswordInput();
          self._showVercodeInput();
          if (validator.result("#formID")) {
            self._login();
          }
        }
      }
    });
  },

  _showAuthcode: function () {
    Model.captchas({
      method: "get",
      token: false,
      success: function (data) {
        var imgUrl = "/api/captchas/" + data._id + "?r=" + Math.random();
        $("#home-verimg").children("img").attr("src", imgUrl).attr("picid", data.pictureId);
      }
    })
  },

  _login: function () {
    var self = this;
    var username = $("#home-input-user").val();
    var password = $("#home-input-pwd-password").val();
    var pictureId = $("#home-verimg").children("img").attr("picid");
    var code = $("#home-input-ver-custom").val();
    var errorFun = function (error) {
      var bua = navigator.userAgent;
      var regex = new RegExp("MSIE 9[.0-9]{0,}");
      var result = false;
      if (error.error_code == 21304) {
        var remainingTime = error.error.substring(error.error.indexOf("(") + 1, error.error.indexOf(")"));
        dialog.render({
          content: [{lang: 21304}, {html: "<span id='remaining-time'></span>"}, {lang: "seconds"}],
          close: function () {
            if (t) {
              clearInterval(t)
            }
          }
        });
        $("#remaining-time").text(" " + remainingTime + " ");
        function time() {
          s = $("#remaining-time").text();
          s = parseInt(s);
          if (s <= 0) {
            clearInterval(t);
            dialog.close();
            return;
          }
          $("#remaining-time").text(" " + (s - 1) + " ");
        }

        t = setInterval(function () {
          time();
        }, 1000);
      } else {
        if (error.error_code == 21306) {
          dialog.render({
            lang: error.error_code, buttons: [{
              lang: "ok", click: function () {
                dialog.close();
                $("#home-input-ver-custom").focus();
              }
            }]
          });
        } else if (error.error_code == 20002) {
          dialog.render({
            lang: error.error_code, buttons: [{
              lang: "ok", click: function () {
                dialog.close();
                $("#home-input-user").focus();
              }
            }]
          });
        } else if (error.error_code == 21302) {
          if (result) {
            dialog.render({
              lang: error.error_code,
              container: "#home-content-bottom-div-top",
              buttons: [{
                lang: "ok", click: function () {
                  dialog.close();
                  $("#home-input-user").focus();
                }
              }]
            });
          }
          else {
            dialog.render({
              lang: error.error_code, buttons: [{
                lang: "ok", click: function () {
                  dialog.close();
                  $("#home-input-user").focus();
                }
              }]
            });
          }
        } else {
          if (result) {
            dialog.render({lang: error.error_code, container: "#home-content-bottom-div-top"});
          } else {
            dialog.render({lang: error.error_code});
          }
        }
      }
    };
    Model.user({
      method: "login",
      data: {
        username: username,
        password: password,
        pictureId: pictureId,
        code: code
      },
      param: {
        language: locale.current()
      },
      error: function (error) {
        self._showAuthcode();
        errorFun(error);
      }
    })
  }
});

module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/index.js
// module id = 0
// module chunks = 0